import axios from "axios";

export default {
  getAll() {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/formas-pago`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
};
